import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
 
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  FlatList,
  RefreshControl,
  Animated,
  ActivityIndicator,
  Share,
  Linking,
} from 'react-native';
import { apiFetch } from '../../utils/apiClient';
import {


  Ionicons,
  MaterialIcons,
  FontAwesome5,
  MaterialCommunityIcons,
} from '@expo/vector-icons';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// JOBENG Logo component
const JobengLogo = () => (
  <Image
    source={require('../../../assets/jobeng_icon.png')}
    style={{ width: 30, height: 30 }}
    resizeMode="contain"
  />
);

export default function CourseDetailsScreen({ navigation, route }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_scoursedetailsscreen`;
    apiFetch('/api/data/jobs?sort=created_at&order=desc&limit=10').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [course, setCourse] = useState(null);
  const [activeTab, setActiveTab] = useState('Overview');
  const [error, setError] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [isEnrolled, setIsEnrolled] = useState(false);

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;

  // Mock data for courses (same as in SkillDevelopmentScreen)
  const mockCourses = [
    {
      id: '1',
      title: 'Technical Interview Preparation',
      provider: 'JobEng Academy',
      category: 'Career Skills',
      level: 'Beginner',
      duration: '4 weeks',
      format: 'Online, self-paced',
      description:
        'Master technical interviews with this comprehensive course covering data structures, algorithms, system design, and behavioral questions. Includes mock interviews and personalized feedback.',
      skills: [
        'Data structures',
        'Algorithms',
        'System design',
        'Problem-solving',
        'Communication',
      ],
      rating: 4.8,
      reviews: 245,
      price: 'Free for JobEng members',
      startDate: 'Start anytime',
      image: 'https://example.com/tech-interview-course.jpg',
      isFeatured: true,
      isPopular: true,
      completionRate: '87%',
      certificateOffered: true,
      instructors: [
        {
          name: 'Dr. Sarah Johnson',
          title: 'Senior Technical Interviewer at Google',
          bio: 'Dr. Johnson has conducted over 500 technical interviews and helped hundreds of candidates prepare for roles at top tech companies.',
          image: 'https://randomuser.me/api/portraits/women/23.jpg',
        },
        {
          name: 'Michael Chen',
          title: 'Engineering Manager at Microsoft',
          bio: 'Michael has 15 years of experience in software engineering and has been on both sides of the interview table throughout his career.',
          image: 'https://randomuser.me/api/portraits/men/45.jpg',
        },
      ],
      syllabus: [
        {
          week: 'Week 1',
          title: 'Data Structures Fundamentals',
          topics: [
            'Arrays and Strings',
            'Linked Lists',
            'Stacks and Queues',
            'Trees and Graphs',
          ],
          assignments: ['Practice problems', 'Coding exercises'],
        },
        {
          week: 'Week 2',
          title: 'Algorithms and Problem Solving',
          topics: [
            'Sorting and Searching',
            'Recursion',
            'Dynamic Programming',
            'Greedy Algorithms',
          ],
          assignments: ['Algorithm implementation', 'Time complexity analysis'],
        },
        {
          week: 'Week 3',
          title: 'System Design and Architecture',
          topics: [
            'Scalability Principles',
            'Database Design',
            'API Design',
            'Microservices',
          ],
          assignments: ['System design exercise', 'Architecture diagram'],
        },
        {
          week: 'Week 4',
          title: 'Behavioral Questions and Mock Interviews',
          topics: [
            'STAR Method',
            'Common Behavioral Questions',
            'Mock Technical Interviews',
            'Feedback and Improvement',
          ],
          assignments: ['Mock interview', 'Self-assessment'],
        },
      ],
      reviews: [
        {
          id: 'r1',
          name: 'James Wilson',
          rating: 5,
          date: '2025-05-15',
          comment:
            'This course completely transformed my interview performance. I went from struggling with technical questions to confidently solving problems during interviews. Highly recommended!',
          image: 'https://randomuser.me/api/portraits/men/32.jpg',
        },
        {
          id: 'r2',
          name: 'Emily Chen',
          rating: 4,
          date: '2025-05-10',
          comment:
            'Great content and structure. The mock interviews were particularly helpful. Would have liked more advanced algorithm coverage, but overall excellent preparation.',
          image: 'https://randomuser.me/api/portraits/women/44.jpg',
        },
        {
          id: 'r3',
          name: 'David Rodriguez',
          rating: 5,
          date: '2025-05-02',
          comment:
            'After completing this course, I received offers from two major tech companies. The system design section was especially valuable as it s often overlooked in other courses.',
          image: 'https://randomuser.me/api/portraits/men/67.jpg',
        },
      ],
      faqs: [
        {
          question: 'How much time should I dedicate to this course each week?',
          answer:
            'We recommend allocating 8-10 hours per week to get the most out of the course materials, practice problems, and assignments.',
        },
        {
          question: 'Is prior coding experience required?',
          answer:
            'Yes, this course assumes basic proficiency in at least one programming language (preferably Python, Java, or C++). You should be comfortable with fundamental programming concepts.',
        },
        {
          question: 'Will I receive a certificate upon completion?',
          answer:
            'Yes, you will receive a JobEng Academy certificate that you can add to your LinkedIn profile and resume.',
        },
        {
          question: 'How long will I have access to the course materials?',
          answer:
            'As a JobEng member, you will have unlimited access to all course materials, including any future updates.',
        },
      ],
      requirements: [
        'Basic programming knowledge in at least one language',
        'Understanding of fundamental data structures',
        'Computer with internet access',
        'Willingness to practice regularly',
      ],
    },
    {
      id: '2',
      title: 'Python for Data Analysis',
      provider: 'DataCamp',
      category: 'Technical',
      level: 'Intermediate',
      duration: '6 weeks',
      format: 'Online, instructor-led',
      description:
        'Learn how to use Python for data analysis, visualization, and interpretation. Master pandas, NumPy, Matplotlib, and other essential libraries for data science.',
      skills: [
        'Python programming',
        'Data analysis',
        'Data visualization',
        'Statistical analysis',
        'Pandas & NumPy',
      ],
      rating: 4.7,
      reviews: 1250,
      price: '£49.99',
      startDate: '2025-07-15',
      image: 'https://example.com/python-data-analysis.jpg',
      isFeatured: false,
      isPopular: true,
      completionRate: '72%',
      certificateOffered: true,
      instructors: [
        {
          name: 'Dr. Alex Johnson',
          title: 'Data Science Lead at DataCamp',
          bio: 'Dr. Johnson has over 10 years of experience in data science and has taught Python to thousands of students worldwide.',
          image: 'https://randomuser.me/api/portraits/men/32.jpg',
        },
      ],
      syllabus: [
        {
          week: 'Week 1',
          title: 'Python Fundamentals for Data Analysis',
          topics: [
            'Python Basics Review',
            'Introduction to NumPy',
            'Array Operations',
            'Vectorized Calculations',
          ],
          assignments: ['NumPy exercises', 'Basic data manipulation'],
        },
        {
          week: 'Week 2',
          title: 'Data Manipulation with Pandas',
          topics: [
            'DataFrame Basics',
            'Data Selection and Filtering',
            'Handling Missing Data',
            'Data Transformation',
          ],
          assignments: [
            'Pandas data cleaning project',
            'Data manipulation exercises',
          ],
        },
        {
          week: 'Week 3',
          title: 'Data Visualization',
          topics: [
            'Matplotlib Fundamentals',
            'Seaborn for Statistical Visualization',
            'Interactive Plots with Plotly',
            'Customizing Visualizations',
          ],
          assignments: [
            'Visualization portfolio',
            'Data storytelling exercise',
          ],
        },
        {
          week: 'Week 4',
          title: 'Statistical Analysis in Python',
          topics: [
            'Descriptive Statistics',
            'Hypothesis Testing',
            'Correlation Analysis',
            'Regression Basics',
          ],
          assignments: [
            'Statistical analysis project',
            'Hypothesis testing exercise',
          ],
        },
        {
          week: 'Week 5',
          title: 'Time Series Analysis',
          topics: [
            'Time Series Data Structures',
            'Resampling and Shifting',
            'Rolling Window Functions',
            'Time Series Visualization',
          ],
          assignments: ['Time series analysis project', 'Forecasting exercise'],
        },
        {
          week: 'Week 6',
          title: 'Capstone Project',
          topics: [
            'Project Planning',
            'Data Collection and Cleaning',
            'Analysis and Visualization',
            'Presenting Results',
          ],
          assignments: [
            'End-to-end data analysis project',
            'Final presentation',
          ],
        },
      ],
      reviews: [
        {
          id: 'r4',
          name: 'Sarah Miller',
          rating: 5,
          date: '2025-04-20',
          comment:
            'Excellent course! The hands-on approach really helped me understand how to apply Python to real-world data problems. The instructor was knowledgeable and responsive.',
          image: 'https://randomuser.me/api/portraits/women/22.jpg',
        },
        {
          id: 'r5',
          name: 'Robert Taylor',
          rating: 4,
          date: '2025-04-15',
          comment:
            'Very comprehensive coverage of pandas and NumPy. The visualization section was particularly useful for my work. Would have liked more advanced statistical content.',
          image: 'https://randomuser.me/api/portraits/men/22.jpg',
        },
      ],
      faqs: [
        {
          question: 'What level of Python knowledge is required?',
          answer:
            'You should have basic Python programming knowledge, including understanding of variables, functions, loops, and conditionals.',
        },
        {
          question: 'What software will I need?',
          answer:
            'You will need Python 3.7 or higher and we recommend using Jupyter Notebooks. All required libraries will be installed during the course setup.',
        },
        {
          question: 'Is this course suitable for data science beginners?',
          answer:
            'This course is designed for intermediate Python users who want to apply their skills to data analysis. Complete beginners may want to take an introductory Python course first.',
        },
      ],
      requirements: [
        'Basic Python programming knowledge',
        'Understanding of basic statistical concepts',
        'Computer with at least 8GB RAM',
        'Stable internet connection',
      ],
    },
  ];

  // Load course details when component mounts
  useEffect(() => {
    if (!route.params?.courseId) {
      setError('No course ID provided');
      setIsLoading(false);
      return;
    }

    // Simulate API call
    setTimeout(() => {
      try {
        const foundCourse = mockCourses.find(
          c => c.id === route.params.courseId
        );

        if (foundCourse) {
          setCourse(foundCourse);
          setError(null);
        } else {
          setError('Course not found');
        }
      } catch (err) {
        setError('Failed to load course details');
        console.error('Error loading course:', err);
      } finally {
        setIsLoading(false);

        // Animate content in
        Animated.parallel([
          Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnim, {
            toValue: 0,
            duration: 500,
            useNativeDriver: true,
          }),
        ]).start();
      }
    }, 1000);
  }, [route.params?.courseId, fadeAnim, slideAnim]);

  // Format date
  const formatDate = dateString => {
    if (dateString === 'Start anytime') return dateString;
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Handle enroll button press — route to the real Stripe purchase flow.
  // (Previous implementation flipped local state and skipped payment entirely.)
  const handleEnroll = () => {
    // If the course is genuinely free, go straight to the skill assessment as before.
    const isFreeCourse = course?.isFree === true
      || course?.price === 0
      || course?.price === '0'
      || course?.price === '£0'
      || course?.price === 'Free';

    if (isFreeCourse) {
      setIsEnrolled(true);
      setTimeout(() => {
        navigation.navigate('SkillAssessment', { courseId: course?.id });
      }, 600);
      return;
    }

    // Paid course → route through the purchase + Stripe payment flow.
    navigation.navigate('CoursePurchaseScreen', {
      course,
      courseId: course?.id,
    });
  };

  // Handle share button press
  const handleShare = async () => {
    try {
      await Share.share({
        message: `Check out this course: ${course.title} by ${course.provider}. ${course.description}`,
        title: course.title,
      });
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  // Handle save button press
  const handleSave = () => {
    setIsSaved(!isSaved);
    // In a real app, this would save to user's profile or local storage
  };

  // Handle contact provider
  const handleContact = () => {
    // In a real app, this would open email or messaging
    alert('Contact feature would open email or messaging to the provider');
  };

  // Render loading state
  const renderLoading = () => (
    <View style={styles.loadingContainer}>
      <ActivityIndicator size={36} color="#0e4e96" />
      <Text style={styles.loadingText}>Loading course details...</Text>
    </View>
  );

  // Render error state
  const renderError = () => (
    <View style={styles.errorContainer}>
      <Ionicons name="alert-circle-outline" size={60} color="#EF4444" />
      <Text style={styles.errorTitle}>Error</Text>
      <Text style={styles.errorMessage}>{error}</Text>
      <TouchableOpacity
        style={styles.errorButton}
        onPress={() => navigation.goBack()}
      >
        <Text style={styles.errorButtonText}>Go Back</Text>
      </TouchableOpacity>
    </View>
  );

  // Render instructor item
  const renderInstructorItem = ({ item }) => (
    <View style={styles.instructorCard}>
      <Image
        source={{ uri: (item.image && typeof item.image==='string' && item.image.startsWith('http')) ? item.image : undefined }}
        style={styles.instructorImage}
        defaultSource={require('../../../assets/default_avatar.png')}
      />
      <View style={styles.instructorInfo}>
        <Text style={styles.instructorName}>{item.name}</Text>
        <Text style={styles.instructorTitle}>{item.title}</Text>
        <Text style={styles.instructorBio}>{item.bio}</Text>
      </View>
    </View>
  );

  // Render review item
  const renderReviewItem = ({ item }) => (
    <View style={styles.reviewCard}>
      <View style={styles.reviewHeader}>
        <Image
          source={{ uri: (item.image && typeof item.image==='string' && item.image.startsWith('http')) ? item.image : undefined }}
          style={styles.reviewerImage}
          defaultSource={require('../../../assets/default_avatar.png')}
        />
        <View style={styles.reviewerInfo}>
          <Text style={styles.reviewerName}>{item.name}</Text>
          <Text style={styles.reviewDate}>{formatDate(item.date)}</Text>
        </View>
        <View style={styles.ratingContainer}>
          {[1, 2, 3, 4, 5].map(star => (
            <Ionicons
              key={star}
              name={star <= item.rating ? 'star' : 'star-outline'}
              size={16}
              color={star <= item.rating ? '#FFB800' : '#CBD5E1'}
            />
          ))}
        </View>
      </View>
      <Text style={styles.reviewComment}>{item.comment}</Text>
    </View>
  );

  // Render syllabus item
  const renderSyllabusItem = ({ item, index }) => (
    <View style={styles.syllabusItem}>
      <View style={styles.syllabusHeader}>
        <View style={styles.weekBadge}>
          <Text style={styles.weekBadgeText}>{item.week}</Text>
        </View>
        <Text style={styles.syllabusTitle}>{item.title}</Text>
      </View>

      <View style={styles.syllabusContent}>
        <Text style={styles.syllabusSubtitle}>Topics:</Text>
        <View style={styles.topicsList}>
          {item.topics.map((topic, idx) => (
            <View key={idx} style={styles.topicItem}>
              <View style={styles.topicBullet} />
              <Text style={styles.topicText}>{topic}</Text>
            </View>
          ))}
        </View>

        <Text style={styles.syllabusSubtitle}>Assignments:</Text>
        <View style={styles.assignmentsList}>
          {item.assignments.map((assignment, idx) => (
            <View key={idx} style={styles.assignmentItem}>
              <MaterialIcons name="assignment" size={16} color="#0e4e96" />
              <Text style={styles.assignmentText}>{assignment}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );

  // Render FAQ item
  const renderFaqItem = ({ item, index }) => (
    <View style={styles.faqItem}>
      <Text style={styles.faqQuestion}>
        {index + 1}. {item.question}
      </Text>
      <Text style={styles.faqAnswer}>{item.answer}</Text>
    </View>
  );

  // Render overview tab
  const renderOverviewTab = () => (
    <View style={styles.tabContent}>
      <Text style={styles.sectionTitle}>About This Course</Text>
      <Text style={styles.description}>{course.description}</Text>

      <Text style={styles.sectionTitle}>What You'll Learn</Text>
      <View style={styles.skillsList}>
        {course.skills.map((skill, index) => (
          <View key={index} style={styles.skillItem}>
            <MaterialIcons name="check-circle" size={20} color="#10B981" />
            <Text style={styles.skillText}>{skill}</Text>
          </View>
        ))}
      </View>

      <Text style={styles.sectionTitle}>Key Information</Text>
      <View style={styles.infoGrid}>
        <View style={styles.infoItem}>
          <MaterialCommunityIcons
            name="school-outline"
            size={24}
            color="#0e4e96"
          />
          <Text style={styles.infoLabel}>Level</Text>
          <Text style={styles.infoValue}>{course.level}</Text>
        </View>

        <View style={styles.infoItem}>
          <MaterialCommunityIcons
            name="calendar-range"
            size={24}
            color="#0e4e96"
          />
          <Text style={styles.infoLabel}>Duration</Text>
          <Text style={styles.infoValue}>{course.duration}</Text>
        </View>

        <View style={styles.infoItem}>
          <MaterialCommunityIcons name="laptop" size={24} color="#0e4e96" />
          <Text style={styles.infoLabel}>Format</Text>
          <Text style={styles.infoValue}>{course.format}</Text>
        </View>

        <View style={styles.infoItem}>
          <MaterialCommunityIcons
            name="certificate"
            size={24}
            color="#0e4e96"
          />
          <Text style={styles.infoLabel}>Certificate</Text>
          <Text style={styles.infoValue}>
            {course.certificateOffered ? 'Yes' : 'No'}
          </Text>
        </View>

        <View style={styles.infoItem}>
          <MaterialCommunityIcons
            name="currency-gbp"
            size={24}
            color="#0e4e96"
          />
          <Text style={styles.infoLabel}>Price</Text>
          <Text style={styles.infoValue}>{course.price}</Text>
        </View>

        <View style={styles.infoItem}>
          <MaterialCommunityIcons
            name="calendar-check"
            size={24}
            color="#0e4e96"
          />
          <Text style={styles.infoLabel}>Start Date</Text>
          <Text style={styles.infoValue}>{formatDate(course.startDate)}</Text>
        </View>
      </View>

      {course.requirements && (
        <>
          <Text style={styles.sectionTitle}>Requirements</Text>
          <View style={styles.requirementsList}>
            {course.requirements.map((requirement, index) => (
              <View key={index} style={styles.requirementItem}>
                <MaterialIcons name="arrow-right" size={20} color="#0e4e96" />
                <Text style={styles.requirementText}>{requirement}</Text>
              </View>
            ))}
          </View>
        </>
      )}

      <Text style={styles.sectionTitle}>Provider</Text>
      <View style={styles.providerContainer}>
        <View style={styles.providerInfo}>
          <Text style={styles.providerName}>{course.provider}</Text>
          <Text style={styles.providerCategory}>{course.category}</Text>
          <TouchableOpacity
            style={styles.providerLink}
            onPress={() =>
              Linking.openURL(
                `https://www.google.com/search?q=${encodeURIComponent(course.provider)}`
              )
            }
          >
            <Text style={styles.providerLinkText}>Visit Website</Text>
            <Ionicons name="open-outline" size={16} color="#0e4e96" />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );

  // Render syllabus tab
  const renderSyllabusTab = () => (
    <View style={styles.tabContent}>
      <Text style={styles.sectionTitle}>Course Syllabus</Text>
      <Text style={styles.syllabusDescription}>
        This course is structured to provide a comprehensive learning experience
        with a mix of theoretical concepts and practical applications.
      </Text>

      <FlatList
        data={course.syllabus}
        renderItem={renderSyllabusItem}
        keyExtractor={(item, index) => `syllabus-${index}`}
        scrollEnabled={false}
        contentContainerStyle={styles.syllabusList}
      />
    </View>
  );

  // Render instructors tab
  const renderInstructorsTab = () => (
    <View style={styles.tabContent}>
      <Text style={styles.sectionTitle}>Meet Your Instructors</Text>
      <Text style={styles.instructorsDescription}>
        Learn from industry experts with extensive experience in their fields.
      </Text>

      <FlatList
        data={course.instructors}
        renderItem={renderInstructorItem}
        keyExtractor={(item, index) => `instructor-${index}`}
        scrollEnabled={false}
        contentContainerStyle={styles.instructorsList}
      />

      {course.reviews && course.reviews.length > 0 && (
        <>
          <Text style={styles.sectionTitle}>Student Reviews</Text>
          <View style={styles.overallRating}>
            <Text style={styles.ratingNumber}>{course.rating.toFixed(1)}</Text>
            <View style={styles.starsContainer}>
              {[1, 2, 3, 4, 5].map(star => (
                <Ionicons
                  key={star}
                  name={
                    star <= Math.round(course.rating) ? 'star' : 'star-outline'
                  }
                  size={20}
                  color={
                    star <= Math.round(course.rating) ? '#FFB800' : '#CBD5E1'
                  }
                />
              ))}
            </View>
            <Text style={styles.reviewCount}>({course.reviews} reviews)</Text>
          </View>

          <FlatList
            data={course.reviews}
            renderItem={renderReviewItem}
            keyExtractor={item => item.id}
            scrollEnabled={false}
            contentContainerStyle={styles.reviewsList}
          />
        </>
      )}
    </View>
  );

  // Render FAQs tab
  const renderFaqsTab = () => (
    <View style={styles.tabContent}>
      <Text style={styles.sectionTitle}>Frequently Asked Questions</Text>

      <FlatList
        data={course.faqs}
        renderItem={renderFaqItem}
        keyExtractor={(item, index) => `faq-${index}`}
        scrollEnabled={false}
        contentContainerStyle={styles.faqsList}
      />

      <View style={styles.contactSection}>
        <Text style={styles.contactTitle}>Still have questions?</Text>
        <TouchableOpacity style={styles.contactButton} onPress={handleContact}>
          <Text style={styles.contactButtonText}>Contact Provider</Text>
        </TouchableOpacity>
      </View>
    </View>
  );

  // Render content based on active tab
  const renderTabContent = () => {
    switch (activeTab) {
      case 'Overview':
        return renderOverviewTab();
      case 'Syllabus':
        return renderSyllabusTab();
      case 'Instructors':
        return renderInstructorsTab();
      case 'FAQs':
        return renderFaqsTab();
      default:
        return renderOverviewTab();
    }
  };

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="chevron-back" size={24} color="#fff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Course Details</Text>
        <JobengLogo />
      </View>

      {isLoading ? (
        renderLoading()
      ) : error ? (
        renderError()
      ) : (
        <ScrollView
          style={styles.container}
          showsVerticalScrollIndicator={false}
        >
          <Animated.View
            style={[
              styles.content,
              {
                opacity: fadeAnim,
                transform: [{ translateY: slideAnim }],
              },
            ]}
          >
            {/* Course Header */}
            <View style={styles.courseHeader}>
              <View style={styles.courseTitleContainer}>
                <Text style={styles.courseTitle}>{course.title}</Text>
                <Text style={styles.courseProvider}>{course.provider}</Text>

                <View style={styles.courseMeta}>
                  <View style={styles.metaItem}>
                    <MaterialCommunityIcons
                      name="school-outline"
                      size={16}
                      color="#64748B"
                    />
                    <Text style={styles.metaText}>{course.level}</Text>
                  </View>

                  <View style={styles.metaItem}>
                    <MaterialCommunityIcons
                      name="calendar-range"
                      size={16}
                      color="#64748B"
                    />
                    <Text style={styles.metaText}>{course.duration}</Text>
                  </View>

                  <View style={styles.metaItem}>
                    <MaterialCommunityIcons
                      name="laptop"
                      size={16}
                      color="#64748B"
                    />
                    <Text style={styles.metaText}>{course.format}</Text>
                  </View>
                </View>

                <View style={styles.ratingBadge}>
                  <Ionicons name="star" size={14} color="#FFB800" />
                  <Text style={styles.ratingBadgeText}>
                    {course.rating} ({course.reviews} reviews)
                  </Text>
                </View>
              </View>

              <View style={styles.courseActions}>
                <TouchableOpacity
                  style={styles.actionButton}
                  onPress={handleShare}
                >
                  <Ionicons
                    name="share-social-outline"
                    size={22}
                    color="#64748B"
                  />
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.actionButton}
                  onPress={handleSave}
                >
                  <Ionicons
                    name={isSaved ? 'bookmark' : 'bookmark-outline'}
                    size={22}
                    color={isSaved ? '#0e4e96' : '#64748B'}
                  />
                </TouchableOpacity>
              </View>
            </View>

            {/* Tab Navigation */}
            <View style={styles.tabContainer}>
              {['Overview', 'Syllabus', 'Instructors', 'FAQs'].map(tab => (
                <TouchableOpacity
                  key={tab}
                  style={[
                    styles.tabButton,
                    activeTab === tab && styles.activeTabButton,
                  ]}
                  onPress={() => setActiveTab(tab)}
                >
                  <Text
                    style={[
                      styles.tabText,
                      activeTab === tab && styles.activeTabText,
                    ]}
                  >
                    {tab}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>

            {/* Tab Content */}
            {renderTabContent()}

            {/* Enroll Button (Fixed at bottom) */}
            <View style={styles.bottomButtonContainer}>
              <TouchableOpacity
                style={[
                  styles.bottomEnrollButton,
                  isEnrolled && styles.enrolledButton,
                ]}
                onPress={handleEnroll}
                disabled={isEnrolled}
              >
                <Text style={styles.bottomEnrollButtonText}>
                  {isEnrolled ? 'Enrolled' : 'Enroll Now'}
                </Text>
                {!isEnrolled && (
                  <Text style={styles.priceText}>{course.price}</Text>
                )}
              </TouchableOpacity>
            </View>
          </Animated.View>
        </ScrollView>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#f5f7fa',
  },
  header: {
    backgroundColor: '#0e4e96',
    paddingVertical: 15,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    padding: 5,
  },
  headerTitle: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
  },
  container: {
    flex: 1,
  },
  content: {
    padding: 16,
  },

  // Loading and Error States
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 10,
    fontSize: 16,
    color: '#64748B',
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
    marginTop: 10,
  },
  errorMessage: {
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 20,
  },
  errorButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
  },
  errorButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },

  // Course Header
  courseHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  courseTitleContainer: {
    flex: 1,
  },
  courseTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  courseProvider: {
    fontSize: 16,
    color: '#64748B',
    marginBottom: 8,
  },
  courseMeta: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  metaItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    marginBottom: 4,
  },
  metaText: {
    fontSize: 14,
    color: '#64748B',
    marginLeft: 4,
  },
  ratingBadge: {
    backgroundColor: '#FEF3C7',
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 16,
    alignSelf: 'flex-start',
  },
  ratingBadgeText: {
    color: '#92400E',
    fontSize: 12,
    fontWeight: '500',
    marginLeft: 4,
  },
  courseActions: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  actionButton: {
    padding: 8,
    marginLeft: 8,
  },

  // Tab Navigation
  tabContainer: {
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: 8,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  tabButton: {
    flex: 1,
    paddingVertical: 12,
    alignItems: 'center',
  },
  activeTabButton: {
    borderBottomWidth: 2,
    borderBottomColor: '#0e4e96',
  },
  tabText: {
    fontSize: 14,
    color: '#64748B',
  },
  activeTabText: {
    color: '#0e4e96',
    fontWeight: 'bold',
  },

  // Tab Content
  tabContent: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 12,
  },
  description: {
    fontSize: 15,
    color: '#333',
    lineHeight: 22,
    marginBottom: 20,
  },

  // Skills List
  skillsList: {
    marginBottom: 20,
  },
  skillItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  skillText: {
    fontSize: 15,
    color: '#333',
    marginLeft: 10,
    flex: 1,
  },

  // Info Grid
  infoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  infoItem: {
    width: '48%',
    backgroundColor: '#f8fafc',
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    alignItems: 'center',
  },
  infoLabel: {
    fontSize: 12,
    color: '#64748B',
    marginTop: 6,
  },
  infoValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    marginTop: 2,
    textAlign: 'center',
  },

  // Requirements List
  requirementsList: {
    marginBottom: 20,
  },
  requirementItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  requirementText: {
    fontSize: 15,
    color: '#333',
    marginLeft: 10,
    flex: 1,
  },

  // Provider
  providerContainer: {
    backgroundColor: '#f8fafc',
    borderRadius: 8,
    padding: 16,
    marginBottom: 20,
  },
  providerInfo: {
    flex: 1,
  },
  providerName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 2,
  },
  providerCategory: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 8,
  },
  providerLink: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  providerLinkText: {
    fontSize: 14,
    color: '#0e4e96',
    fontWeight: '500',
    marginRight: 4,
  },

  // Syllabus Tab
  syllabusDescription: {
    fontSize: 15,
    color: '#333',
    lineHeight: 22,
    marginBottom: 16,
  },
  syllabusList: {
    paddingBottom: 8,
  },
  syllabusItem: {
    backgroundColor: '#f8fafc',
    borderRadius: 8,
    marginBottom: 16,
    overflow: 'hidden',
  },
  syllabusHeader: {
    backgroundColor: '#0e4e96',
    padding: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  weekBadge: {
    backgroundColor: '#fff',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 4,
    marginRight: 10,
  },
  weekBadgeText: {
    color: '#0e4e96',
    fontSize: 12,
    fontWeight: 'bold',
  },
  syllabusTitle: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
    flex: 1,
  },
  syllabusContent: {
    padding: 12,
  },
  syllabusSubtitle: {
    fontSize: 15,
    fontWeight: '600',
    color: '#333',
    marginBottom: 8,
    marginTop: 4,
  },
  topicsList: {
    marginBottom: 12,
  },
  topicItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  topicBullet: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#0e4e96',
    marginRight: 8,
  },
  topicText: {
    fontSize: 14,
    color: '#333',
  },
  assignmentsList: {
    marginBottom: 4,
  },
  assignmentItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  assignmentText: {
    fontSize: 14,
    color: '#333',
    marginLeft: 8,
  },

  // Instructors Tab
  instructorsDescription: {
    fontSize: 15,
    color: '#333',
    lineHeight: 22,
    marginBottom: 16,
  },
  instructorsList: {
    marginBottom: 20,
  },
  instructorCard: {
    flexDirection: 'row',
    backgroundColor: '#f8fafc',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
  },
  instructorImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#e2e8f0',
  },
  instructorInfo: {
    marginLeft: 16,
    flex: 1,
  },
  instructorName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 2,
  },
  instructorTitle: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 8,
  },
  instructorBio: {
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
  },

  // Reviews
  overallRating: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  ratingNumber: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    marginRight: 12,
  },
  starsContainer: {
    flexDirection: 'row',
    marginRight: 8,
  },
  reviewCount: {
    fontSize: 14,
    color: '#64748B',
  },
  reviewsList: {
    marginBottom: 8,
  },
  reviewCard: {
    backgroundColor: '#f8fafc',
    borderRadius: 8,
    padding: 16,
    marginBottom: 12,
  },
  reviewHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  reviewerImage: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#e2e8f0',
    marginRight: 12,
  },
  reviewerInfo: {
    flex: 1,
  },
  reviewerName: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
  },
  reviewDate: {
    fontSize: 12,
    color: '#64748B',
  },
  ratingContainer: {
    flexDirection: 'row',
  },
  reviewComment: {
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
  },

  // FAQs
  faqsList: {
    marginBottom: 20,
  },
  faqItem: {
    marginBottom: 16,
  },
  faqQuestion: {
    fontSize: 15,
    fontWeight: '600',
    color: '#333',
    marginBottom: 6,
  },
  faqAnswer: {
    fontSize: 14,
    color: '#64748B',
    lineHeight: 20,
  },
  contactSection: {
    alignItems: 'center',
    paddingTop: 8,
  },
  contactTitle: {
    fontSize: 16,
    color: '#333',
    marginBottom: 12,
  },
  contactButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#0e4e96',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  contactButtonText: {
    color: '#0e4e96',
    fontSize: 14,
    fontWeight: '600',
  },

  // Bottom Enroll Button
  bottomButtonContainer: {
    marginTop: 16,
    marginBottom: 40,
  },
  bottomEnrollButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 16,
    borderRadius: 8,
    alignItems: 'center',
  },
  enrolledButton: {
    backgroundColor: '#10B981',
  },
  bottomEnrollButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  priceText: {
    color: '#fff',
    fontSize: 14,
    marginTop: 4,
  },
});
